import i18n from "i18next";
import ChainedBackend from "i18next-chained-backend";
import HttpBackend from "i18next-http-backend";
import resourcesToBackend from "i18next-resources-to-backend";
import { useAtomValue } from "jotai";
import { useEffect } from "react";
import { initReactI18next } from "react-i18next";

import { i18nextConfig } from "app/constants";
import { clientConfigAtom } from "atoms/clientConfig";
import { getUserLocale } from "utils/locale/userLocale";

export const useInitialiseLocalisation = () => {
  const { locale } = useAtomValue(clientConfigAtom);

  useEffect(() => {
    const resolvedLocale = getUserLocale(locale);

    i18n
      .use(ChainedBackend)
      .use(initReactI18next)
      .init({
        lng: resolvedLocale,
        ...i18nextConfig,
        backend: {
          backends: [
            HttpBackend,
            resourcesToBackend((lng, _ns, clb) => {
              import(`../../fallbackContent/${lng}.json`) // This fallback is only used if the primary method fails
                .then((resources) => clb(null, resources))
                .catch((error) => clb(error, null));
            }),
          ],
          backendOptions: [
            {
              loadPath: "https://public.prod-euce1.assets.tractable.io/car-owner-app/translations/{{lng}}.json",
            },
          ],
        },
      });
  }, [locale]);
};
